import classNames from 'classnames';
import React, { useRef, useState } from 'react';
import { connect } from 'react-redux';
import { selectSectionAndCategory, setActiveFilterButton } from '../../actions';

const SubLevelFilter = ({
    toplevel,
    filterType,
    filterHandle,
    filterDisplayName,
    handleSubLevelFilterPress,
    activeFilter,
    filterNamespace,
    filterKey,
}) => {
    const firstLetterUppercase = filterHandle?.charAt(0).toUpperCase();
    const remainingLetters = filterHandle.slice(1);
    const filterHandleMetafield = `${firstLetterUppercase}${remainingLetters}`;
    const filterClassName = classNames('sub-level__filter ', {
        active: activeFilter?.toLowerCase() === filterHandle?.toLowerCase(),
    });

    return (
        <button
            key={filterHandle}
            className={filterClassName}
            onClick={(e) => handleSubLevelFilterPress(e)}
            data-toplevel={toplevel}
            data-filtertype={filterType}
            data-filterhandle={filterType === 'collection' ? filterHandle : filterHandleMetafield}
            data-filternamespace={filterNamespace}
            data-filterkey={filterKey}
        >
            {filterDisplayName}
        </button>
    );
};

const ProductFilters = ({ dispatch, activeSection, activeFilter, skintone, filters }) => {
    const [currentTopLevelFilter, setCurrentTopLevelFilter] = useState(activeFilter?.filterTopLevel || null);
    const topFilters = useRef(0);
    const subFilters = useRef(0);

    let filter = '';
    switch (activeSection) {
        case 'accessory1':
        case 'accessory2':
        case 'accessory3':
        case 'accessory4':
            filter = filters.filter((f) => f.section === 'accessories');
            break;
        default:
            filter = filters.filter((f) => f.section === activeSection);
    }

    const handleTopLevelFilterPress = (e) => {
        const clickedFilter = e.target;
        setCurrentTopLevelFilter(clickedFilter.dataset.toplevel);

        const topFilterList = Array.from(topFilters.current.querySelectorAll('button'));
        topFilterList.forEach((topFilter) => {
            if (topFilter.dataset.toplevel !== clickedFilter.dataset.toplevel) {
                topFilter.classList.remove('active');
            } else {
                topFilter.classList.add('active');
            }
        });

        if (clickedFilter.dataset.filtertype === 'collection') {
            fetchFilteredProducts(clickedFilter);
        } else {
            // Delay fetching subfilters to ensure state has updated
            setTimeout(() => {
                // Find the first subfilter for the clicked toplevel filter if toplevel isn't a collection
                const subFilterList = Array.from(subFilters.current.querySelectorAll('button'));
                const firstSubFilter = subFilterList.find(
                    (subFilter) => subFilter.dataset.toplevel === clickedFilter.dataset.toplevel
                );
                if (firstSubFilter) {
                    fetchFilteredProducts(firstSubFilter);
                }
            }, 0);
        }
    };

    const handleSubLevelFilterPress = (e) => {
        const clickedFilter = e.target;

        fetchFilteredProducts(clickedFilter);
    };

    const fetchFilteredProducts = (clickedFilter) => {
        // console.log(`show products for ${clickedFilter.dataset.filtertype} of ${clickedFilter.dataset.filterhandle}`);

        if (clickedFilter.dataset.filtertype === 'collection') {
            dispatch(
                selectSectionAndCategory(
                    {
                        id: activeSection,
                        title: '',
                        emptyText: '',
                        handle: clickedFilter.dataset.filterhandle,
                    },
                    null,
                    skintone
                )
            );
        } else if (clickedFilter.dataset.filtertype === 'metafield') {
            dispatch(
                selectSectionAndCategory(
                    {
                        id: activeSection,
                        title: '',
                        emptyText: '',
                        handle: 'all-legs',
                    },
                    {
                        key: clickedFilter.dataset.filterkey, // e.g. colour
                        namespace: clickedFilter.dataset.filternamespace, // e.g. custom
                        value: clickedFilter.dataset.filterhandle, // e.g. blue
                    },
                    skintone
                )
            );
        }

        dispatch(
            setActiveFilterButton({
                filterType: clickedFilter.dataset.filtertype,
                filterHandle: clickedFilter.dataset.filterhandle,
                filterTopLevel: clickedFilter.dataset.toplevel,
            })
        );
    };

    if (!filter) {
        return <></>;
    }

    return (
        <div id="buy-bits-container">
            <div className="filters">
                <div className="top-level" ref={topFilters}>
                    {filter.map((filter) =>
                    filter.subFilters ? (
                        <button
                            key={filter.filterDisplayName}
                            className={`filter ${currentTopLevelFilter === filter.filterDisplayName ? 'active' : ''}`}
                            onClick={(e) => handleTopLevelFilterPress(e)}
                            data-toplevel={filter.filterDisplayName}
                        >
                            {filter.filterDisplayName}
                        </button>
                    ) : (
                            <button
                                key={filter.filterDisplayName}
                                className={`filter ${currentTopLevelFilter === filter.filterDisplayName ? 'active' : ''}`}
                                onClick={(e) => handleTopLevelFilterPress(e)}
                                data-toplevel={filter.filterDisplayName}
                                data-filtertype={filter.filterType}
                                data-filterhandle={filter.filterHandle}
                            >
                                {filter.filterDisplayName}
                            </button>
                        )
                )}
                </div>

                <div className={`sub-level ${!currentTopLevelFilter ? 'no-scroll' : ''}`} ref={subFilters}>
                    {filter.map((filter) => {
                        return (
                            filter.subFilters &&
                            filter.subFilters.map((subFilter) => {
                                if (
                                    currentTopLevelFilter === filter.filterDisplayName &&
                                    subFilter.filterType &&
                                    subFilter.filterHandle
                                ) {
                                    return (
                                        <SubLevelFilter
                                            key={subFilter.filterHandle}
                                            handleSubLevelFilterPress={(e) => handleSubLevelFilterPress(e)}
                                            toplevel={filter.filterDisplayName}
                                            filterType={subFilter.filterType}
                                            filterHandle={subFilter.filterHandle}
                                            filterDisplayName={subFilter.filterDisplayName}
                                            filterNamespace={subFilter.filterNamespace}
                                            filterKey={subFilter.filterKey}
                                            activeFilter={activeFilter?.filterHandle}
                                        />
                                    );
                                }
                            })
                        );
                    })}
                </div>
            </div>
        </div>
    );
};

const mapStateToProps = (state) => {
    return {
        activeSection: state.navigation.selected,
        products: state.browser.products,
        activeFilter: state.activeFilter,
        skintone: state.builds[state.currentBuildIndex].skintone,
        filters: state.filters,
    };
};

export default connect(mapStateToProps)(ProductFilters);
